export default "__VITE_ASSET__Co8s85kX__"